import { Component, Input, OnInit, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-smblockimage',
    templateUrl: './smblockimage.component.html',
    styleUrls: ['./smblockimage.component.scss'],
    standalone: false
})
  
export class SmblockimageComponent implements OnInit {
  @Input() b: any;
  public basepath = '';

  private api = inject(ApiService);

  constructor(
    public data: DataService
  ) {
  }

  ionViewWillEnter() {
    console.log(' will this.data.basePath');
    console.log(this.data.basePath);
    this.basepath = this.api.getMediaBase();
  }

  ngOnInit() {
    console.log(' init this.data.basePath');
    console.log(this.data.basePath);
    this.basepath = this.api.getMediaBase();
  }
  
  safeURL(item) {
    return encodeURI(item);
  }

  mediaUrl(path: string): string {
    return this.api.mediaUrl(path);
  }
}
